<template>
    <v-menu
        v-model="menu"
        class="conversation-date-field"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template #activator="{ on, attrs }">
            <v-text-field
                :value="displayValue"
                :label="label"
                :clearable="clearable"
                :hide-details="hideDetails"
                prepend-inner-icon="mdi-calendar"
                placeholder="dd/mm/aaaa"
                readonly
                outlined
                dense
                v-bind="attrs"
                v-on="on"
                @click:clear.stop="clearDate"
            />
        </template>

        <v-date-picker
            :value="value"
            locale="pt-BR"
            color="primary"
            no-title
            scrollable
            @input="selectDate"
        />
    </v-menu>
</template>

<script>
export default {
    name: 'ConversationDateField',
    props: {
        value: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            required: true,
        },
        clearable: Boolean,
        hideDetails: {
            type: [Boolean, String],
            default: true,
        },
    },
    data() {
        return {
            menu: false,
        }
    },
    computed: {
        displayValue() {
            if (!this.value) return ''
            return this.value.split('-').reverse().join('/')
        },
    },
    methods: {
        selectDate(value) {
            this.$emit('input', value)
            this.menu = false
        },
        clearDate() {
            this.$emit('input', null)
            this.menu = false
        },
    },
}
</script>

<style scoped>
.conversation-date-field {
    width: 100%;
    min-width: 0;
}
</style>
